module.exports = __webpack_public_path__ + "static/img/214_TO8_2158_og.b9044b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/214_TO8_2158_og.jpg
// module id = Uz+K
// module chunks = 0